export type Bonus = {
  number: string
  title: string
  body: string
  cover: string
}

/**
 * Los 5 bonus reales del pack (ficha DPS-30 · Baseball Practice Ready).
 * Cada `cover` es la portada real del bonus.
 */
export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Pick-My-Practice: The 1-Page Decision Flowchart',
    body: 'Answer three questions — how many kids, how much time, what to focus on — and the flowchart sends you to the exact practice to run today. One printable page, plus a short how-to.',
    cover:
      'https://cdn.magicpatterns.com/uploads/bzYgv57BBnGfVm4HUu7FcS/DPS-30_-_Bono_2_-_Pick-My-Practice_The_1-Page_Decision_Flowchart.png',
  },
  {
    number: '02',
    title: 'The Age & Level Cheat Sheet',
    body: 'For 5-6, 7-8, 9-10, 11-12 and 13+: what to emphasize, which level to run by default (Rookie / Ready / Rising), what to skip, and realistic expectations — so the pack fits the team in front of you.',
    cover:
      'https://cdn.magicpatterns.com/uploads/hU6aWLrdaytk8Ar9tHwX24/DPS-30_-_Bono_3_-_The_Age__Level_Cheat_Sheet.png',
  },
  {
    number: '03',
    title: 'Start Here: The 10-Minute Quick-Start Guide',
    body: 'In ten minutes you go from “just bought it” to “ready for today”: how the pack is organized, how to pick your first practice, and exactly what to print.',
    cover:
      'https://cdn.magicpatterns.com/uploads/tHcmdM31DeUt2okCBcyesL/DPS-30_-_Bono_1_-_Start_Here_The_10-Minute_Quick-Start_Guide.png',
  },
  {
    number: '04',
    title: "The Coach's Confidence Scripts: Exactly What to Say",
    body: 'The exact words for the moments that matter: introducing yourself on day one, explaining a drill in ten seconds, picking up a kid who’s struggling, the pre-game huddle and the two-minute post-game talk.',
    cover:
      'https://cdn.magicpatterns.com/uploads/6TafW44fVpkeEbyPpbXxBP/DPS-30_-_Bono_4_-_The_Coachs_Confidence_Scripts.png',
  },
  {
    number: '05',
    title: 'The Never-Forget Equipment & Budget-Gear Guide',
    body: 'What you absolutely need, cheap substitutions when something’s missing, and a “field setup in 10 minutes” map — so you never show up short a piece of gear again.',
    cover:
      'https://cdn.magicpatterns.com/uploads/rk2BFTcFqdn3sR3Qd3Eotw/DPS-30_-_Bono_5_-_The_Never-Forget_Equipment__Budget-Gear_Guide.png',
  },
]
